import { fetchAPI } from "packs/api";

// Get cookie prefix at runtime to handle script loading order
function getCookiePrefix() {
    return window.appconfig?.cookie_prefix || 'pp_dd';
}

// Hardcoded URLs for both desidime and pepper platforms
const linkSelector = [
  // Relative URLs (for when affiliate_url returns relative paths)
  "a[href^='/visit/']",
  "a[href^='/links']",
  // Desidime URLs
  "a[href^='https://links.desidime.com']",
  "a[href^='http://links.desidime.com']",
  "a[href^='https://www.desidime.com/links']",
  "a[href^='https://www.desidime.com/visit']",
  "a[href^='https://staging.desidime.com/links']",
  "a[href^='https://staging.desidime.com/visit']",
  "a[href^='https://visit.desidime.com/visit']",
  "a[href^='https://staginglinks.desidime.com/visit']",
  "a[href^='https://beta.desidime.com/links']",
  "a[href^='https://beta.desidime.com/visit']",
  // Pepper URLs
  "a[href^='https://www.pepper.ru/visit']",
  "a[href^='https://www.pepper.ru/links']",
  "a[href^='https://live.pepper.ru/visit']",
  "a[href^='https://live.pepper.ru/links']",
  "a[href^='https://staging.pepper.ru/visit']",
  "a[href^='https://staging.pepper.ru/links']",
  // Local development
  "a[href^='http://localhost:8000/visit']",
  "a[href^='http://localhost:8000/links']",
  "a[href^='http://localhost:4000/visit']",
  "a[href^='http://localhost:4000/links']",
  "a[href^='http://localhost:3000/visit']",
  "a[href^='http://localhost:3000/links']"
].join(', ');

// Helper function to get topicOwner value
function getTopicOwner(element) {
    let topicOwner = 0;
    let topicOwnerId = document.getElementById("topicOwner");
    if (topicOwnerId) {
        topicOwner = topicOwnerId.value;
    } else if (element && element.dataset.topicowner) {
        topicOwner = element.dataset.topicowner;
    }
    return topicOwner;
}

// Helper function to get pagePosition value
function getPagePosition(element) {
    let pagePosition = '';
    let pagePositionId = document.getElementById("pagePosition");
    if (pagePositionId) {
        pagePosition = pagePositionId.value;
    } else if (element && element.dataset.pageposition) {
        pagePosition = element.dataset.pageposition;
    }
    return pagePosition;
}

// Helper function to build URL with UTM parameters (aligned with desidime_1.3 logic)
function buildUrlWithParams(baseUrl, element) {
    let device = is_device_mobile() ? 'mobile' : 'desktop';
    let value = baseUrl;
    let user_value = 0;
    let utm_parameter = Cookies.get(`${getCookiePrefix()}_utm_campaign`);
    let current_user_id = document.getElementById("CurrentUserID");

    if (current_user_id) {
        user_value = current_user_id.value;
    }

    let topicOwner = getTopicOwner(element);
    let pagePosition = getPagePosition(element);

    if (value.includes('/visit')) {
        if (!utm_parameter) {
            let params = `ts=direct&dduid=${user_value}&client=${device}&topicOwner=${topicOwner}&pagePosition=${pagePosition}`;
            value += value.includes('?') ? `&${params}` : `?${params}`;
        } else {
            // Only read UTM cookies when utm_campaign exists (like desidime_1.3)
            let utm_medium = Cookies.get(`${getCookiePrefix()}_utm_medium`) || '';
            let utm_source = Cookies.get(`${getCookiePrefix()}_utm_source`) || '';
            let gclid = Cookies.get(`${getCookiePrefix()}_gclid`);
            let fbclid = Cookies.get(`${getCookiePrefix()}_fbclid`);

            // Build params with proper null checks (like desidime_1.3)
            if (fbclid) {
                let params = `ts=Xutm_${utm_parameter}&dduid=${user_value}&client=${device}&us=${utm_source}&um=${utm_medium}&fbclid=${fbclid}&topicOwner=${topicOwner}&pagePosition=${pagePosition}`;
                value += value.includes('?') ? `&${params}` : `?${params}`;
            } else if (gclid) {
                let params = `ts=Xutm_${utm_parameter}&dduid=${user_value}&client=${device}&us=${utm_source}&um=${utm_medium}&gclid=${gclid}&topicOwner=${topicOwner}&pagePosition=${pagePosition}`;
                value += value.includes('?') ? `&${params}` : `?${params}`;
            } else {
                let params = `ts=Xutm_${utm_parameter}&dduid=${user_value}&client=${device}&us=${utm_source}&um=${utm_medium}&topicOwner=${topicOwner}&pagePosition=${pagePosition}`;
                value += value.includes('?') ? `&${params}` : `?${params}`;
            }
        }
    } else {
        // Handle /links URLs with ref parameter
        if (!utm_parameter) {
            value = value.replace(/(ref=)([^&#]*)/, `$1$2&ts=direct&dduid=${user_value}&topicOwner=${topicOwner}&client=${device}&pagePosition=${pagePosition}`);
        } else {
            // Only read UTM cookies when utm_campaign exists (like desidime_1.3)
            let utm_medium = Cookies.get(`${getCookiePrefix()}_utm_medium`) || '';
            let utm_source = Cookies.get(`${getCookiePrefix()}_utm_source`) || '';
            let gclid = Cookies.get(`${getCookiePrefix()}_gclid`);
            let fbclid = Cookies.get(`${getCookiePrefix()}_fbclid`);

            // Build params with proper null checks (like desidime_1.3)
            if (fbclid) {
                let extraParams = `&ts=${utm_parameter}&dduid=${user_value}&topicOwner=${topicOwner}&client=${device}&pagePosition=${pagePosition}&us=${utm_source}&um=${utm_medium}&fbclid=${fbclid}`;
                value = value.replace(/(ref=)([^&#]*)/, `$1$2Xutm_${utm_parameter}${extraParams}`);
            } else if (gclid) {
                let extraParams = `&ts=${utm_parameter}&dduid=${user_value}&topicOwner=${topicOwner}&client=${device}&pagePosition=${pagePosition}&us=${utm_source}&um=${utm_medium}&gclid=${gclid}`;
                value = value.replace(/(ref=)([^&#]*)/, `$1$2Xutm_${utm_parameter}${extraParams}`);
            } else {
                let extraParams = `&ts=${utm_parameter}&dduid=${user_value}&topicOwner=${topicOwner}&client=${device}&pagePosition=${pagePosition}&us=${utm_source}&um=${utm_medium}`;
                value = value.replace(/(ref=)([^&#]*)/, `$1$2Xutm_${utm_parameter}${extraParams}`);
            }
        }
    }

    return value;
}

// Function to initialize link tracking for elements matching linkSelector
function initLinkTracking() {
    document.querySelectorAll(linkSelector).forEach(link => {
        // Skip if already initialized
        if (link.dataset.linkTrackerInitialized) return;
        link.dataset.linkTrackerInitialized = 'true';

        // Store the original href to avoid multiple parameter additions
        link.dataset.originalHref = link.getAttribute('href');

        // Handle right-click or middle-click - update href with parameters before browser opens it
        link.addEventListener("mousedown", function (e) {
            // Right-click (button 2) or middle-click (button 1)
            if (e.button === 2 || e.button === 1) {
                let value = this.dataset.originalHref || this.getAttribute('href');
                let topic_permalink = this.dataset.permalink;

                value = buildUrlWithParams(value, this);

                // Update the href so browser's context menu/middle-click opens the correct URL
                this.setAttribute('href', value);
                update_outbound_click(topic_permalink);

                // Restore original href after a short delay to prevent accumulation
                setTimeout(() => {
                    this.setAttribute('href', this.dataset.originalHref);
                }, 100);
            }
        });

        link.addEventListener("click", function (e) {
            // Prevent duplicate handling if this was triggered by middle-click
            // For Ctrl+Click and Cmd+Click, we need to update href and let browser handle
            if (e.button === 1 || e.ctrlKey || e.metaKey) {
                let value = this.dataset.originalHref || this.getAttribute('href');
                let topic_permalink = this.dataset.permalink;

                value = buildUrlWithParams(value, this);

                // Update href for Ctrl/Cmd+Click to open with correct parameters
                this.setAttribute('href', value);
                update_outbound_click(topic_permalink);

                // Restore original href after browser has read it
                setTimeout(() => {
                    this.setAttribute('href', this.dataset.originalHref);
                }, 100);
                return;
            }

            let value = this.getAttribute('href');
            let topic_permalink = this.dataset.permalink;

            value = buildUrlWithParams(value, this);

            // Prevent default action and open with modified URL
            e.preventDefault();
            window.open(value, "_blank");
            update_outbound_click(topic_permalink);
        });
    });
}

// Initialize on page load - wrap in DOMContentLoaded to ensure DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLinkTracking);
} else {
    // DOM is already ready
    initLinkTracking();
}

// Export for use after dynamic content loads
window.initLinkTracking = initLinkTracking;

// Button click handlers for deal buttons (like desidime_1.3)
// Note: .click_coupons_code is handled separately by coupon_click.js
document.addEventListener('click', function(e) {
    let clickedElement = e.target.closest('.click_static_banner, .redeem-code-btn, .coupon-box-btn, .click_deal_code, .click_offer_code, .click_coupon_discount_description, .btn-getdeal, .btn-lgetdeal, .btn_blue, .btn_green, .btn_orange');

    if (clickedElement) {
        let device = is_device_mobile() ? 'mobile' : 'desktop';
        let utm_parameter = Cookies.get(`${getCookiePrefix()}_utm_campaign`);
        let coupon_type = clickedElement.dataset.tip;
        let value = clickedElement.dataset.href;
        let topic_url = clickedElement.dataset.hrefAlt;
        let user_value = 0;
        let current_user_id = document.getElementById("CurrentUserID");

        if (current_user_id) {
            user_value = current_user_id.value;
        }

        let topicOwner = getTopicOwner(clickedElement);
        let pagePosition = getPagePosition(clickedElement);

        if (value && value.includes('/visit')) {
            if (!utm_parameter) {
                value = value + `?ts=direct&dduid=${user_value}&client=${device}&topicOwner=${topicOwner}&pagePosition=${pagePosition}`;
            } else {
                // Only read UTM cookies when utm_campaign exists (like desidime_1.3)
                let utm_medium = Cookies.get(`${getCookiePrefix()}_utm_medium`) || '';
                let utm_source = Cookies.get(`${getCookiePrefix()}_utm_source`) || '';
                let gclid = Cookies.get(`${getCookiePrefix()}_gclid`);
                let fbclid = Cookies.get(`${getCookiePrefix()}_fbclid`);

                // Build params with proper null checks (like desidime_1.3)
                if (fbclid) {
                    value = value + `?ts=Xutm_${utm_parameter}&dduid=${user_value}&client=${device}&us=${utm_source}&um=${utm_medium}&fbclid=${fbclid}&topicOwner=${topicOwner}&pagePosition=${pagePosition}`;
                } else if (gclid) {
                    value = value + `?ts=Xutm_${utm_parameter}&dduid=${user_value}&client=${device}&us=${utm_source}&um=${utm_medium}&gclid=${gclid}&topicOwner=${topicOwner}&pagePosition=${pagePosition}`;
                } else {
                    value = value + `?ts=Xutm_${utm_parameter}&dduid=${user_value}&client=${device}&us=${utm_source}&um=${utm_medium}&topicOwner=${topicOwner}&pagePosition=${pagePosition}`;
                }
            }
        } else if (value) {
            // Handle /links URLs with ref parameter
            if (!utm_parameter) {
                value = value.replace(/(ref=)([^&#]*)/, `$1$2&ts=direct&dduid=${user_value}&topicOwner=${topicOwner}&client=${device}&pagePosition=${pagePosition}`);
            } else {
                // Only read UTM cookies when utm_campaign exists (like desidime_1.3)
                let utm_medium = Cookies.get(`${getCookiePrefix()}_utm_medium`) || '';
                let utm_source = Cookies.get(`${getCookiePrefix()}_utm_source`) || '';
                let gclid = Cookies.get(`${getCookiePrefix()}_gclid`);
                let fbclid = Cookies.get(`${getCookiePrefix()}_fbclid`);

                // Build params with proper null checks (like desidime_1.3)
                if (fbclid) {
                    let extraParams = `&ts=${utm_parameter}&dduid=${user_value}&topicOwner=${topicOwner}&client=${device}&pagePosition=${pagePosition}&us=${utm_source}&um=${utm_medium}&fbclid=${fbclid}`;
                    value = value.replace(/(ref=)([^&#]*)/, `$1$2Xutm_${utm_parameter}${extraParams}`);
                } else if (gclid) {
                    let extraParams = `&ts=${utm_parameter}&dduid=${user_value}&topicOwner=${topicOwner}&client=${device}&pagePosition=${pagePosition}&us=${utm_source}&um=${utm_medium}&gclid=${gclid}`;
                    value = value.replace(/(ref=)([^&#]*)/, `$1$2Xutm_${utm_parameter}${extraParams}`);
                } else {
                    let extraParams = `&ts=${utm_parameter}&dduid=${user_value}&topicOwner=${topicOwner}&client=${device}&pagePosition=${pagePosition}&us=${utm_source}&um=${utm_medium}`;
                    value = value.replace(/(ref=)([^&#]*)/, `$1$2Xutm_${utm_parameter}${extraParams}`);
                }
            }
        }

        if (value != undefined && topic_url != undefined) {
            if (!coupon_type) {
                window.open(topic_url);
                window.location.href = value;
            } else if (coupon_type && coupon_type == 'coupon_popup') {
                window.open(value, '_blank');
            } else {
                window.open(value, '_blank');
                window.location.href = topic_url;
            }
            update_outbound_click(topic_url);
        }
    }
});

function update_outbound_click(url) {
    fetchAPI("/update_outbound_click", "POST", { url: url }, "text")
        .then(response => {
            // Backend returns {recorded: true/false}
            // console.log("Click tracked:", response);
            // No action required
        })
        .catch(error => {
            console.error("Click tracking failed:", error);
        });
}

function get_current_user_id() {
    let current_user_id = document.getElementById("CurrentUserID");
    return current_user_id ? current_user_id.value : 'guest';
}

function is_device_mobile() {
    return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4)));
}

function card_click() {
    document.addEventListener('click', function (event) {
        let card = event.target.closest('.deal-card, .discussion-card, .user-group');

        if (card) {
            // If the clicked target is one of the excluded elements, stop further actions
            if (event.target.closest('.orange-btn, a, .bookmark-or-mute, .remove-bookmark, .unmute-post')) {
                return;
            }
            // Redirect to the URL specified in the data-permalink attribute
            window.location = `/${card.dataset.permalink}`;
        }
    });
}

window.card_click = card_click;

card_click();
